import { CourseConflictEnum } from './global/types/course_conflict_enum';

/**
 * @phxAcademicPlanner
 */
/**
 * @capability-ng-academic-planner
 */

require('./vendor.ts');
angular.module('capability-ng-smartcatalog', []);

export const ApAppName = 'capability-ng-academic-planner';

angular
  .module(ApAppName, [
    'ngAria',
    'ui.router',
    'ui-ng-ax',
    'ui-ng-modal',
    'ui-ng-drag-drop',
    'ui-ng-smooth-scroll',
    'ui-ng-popover',
    'ui-ng-component-communicator',
    'ui-ng-university-text',
    'ui-ng-sticky',
    'capability-ng-smartcatalog',
    'utility-ng-auth-token',
    'data-ng-custom-text'
  ])
  .factory('CourseConflictEnum', (Enumeration: any) => {
    return Enumeration('CourseConflictEnum', CourseConflictEnum);
  })
  .run(($state: ng.ui.IStateService, $injector: ng.auto.IInjectorService) => {
    window['$INJ'] = $injector;
  })
  .config((authTokenProvider: any) => {
    authTokenProvider.configure({
      authTokenApi: '/ssccampus/token?scheduling_api=None',
      tokenExpiryTime: 5
    });
  });

import './core';

export default ApAppName;



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/main.ts